<div style="display: flex; justify-content: start;  margin: 5px;font-size:small;flex-wrap: wrap;">
  @for (group of this.SkillsGroups; track group) {
    <div style="display: flex; flex-direction: column; margin-right: 10px; ">
      {{group.Name}}
      @for (skill of group.Skills; track skill) {
        <div style="display: flex; flex-direction: row; margin-left: 10px;">
          <div style="min-width: 150px;">{{skill.Text}}</div>
          <div [class]="this.classesRankingBox[skill.Ranking]">{{skill.Ranking}}</div>
        </div>
      }
    </div>
  }
</div>